import clsx from "clsx";

export default function Card({
  children,
  className = "",
  onClick,
  hover,
  glow,
  gradient,
  aurora,
  style,
}) {
  return (
    <div
      onClick={onClick}
      style={style}
      className={clsx(
        "relative rounded-2xl border overflow-hidden",
        "transition-all duration-300",
        /* base surface */
        "bg-nexus-sf border-nexus-border",
        /* hover interactions — interactive cards also get the light sheen sweep */
        hover && [
          "cursor-pointer card-sheen",
          "hover:scale-[1.018] hover:-translate-y-0.5",
          "hover:shadow-flow hover:border-violet-500/35",
          "active:scale-[0.982] active:translate-y-0",
        ],
        /* optional glow */
        glow && "shadow-flow",
        /* gradient inner bg */
        gradient && "bg-gradient-to-br from-nexus-s2 to-nexus-sf",
        /* aurora animated bg */
        aurora && "aurora-bg",
        className
      )}
    >
      {/* Subtle top highlight — a touch of "lit from above" glass */}
      <div
        className="absolute inset-x-0 top-0 h-px pointer-events-none"
        style={{ background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.09), rgba(139,92,246,0.10), transparent)" }}
      />
      {children}
    </div>
  );
}
